import { useQuery } from '@tanstack/react-query';
import {
  musteriGetir,
  musterileriListele,
  type Musteri,
  type MusteriSorgusu,
  type SayfalanmisMusteriler,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useMusteriListesi(sorgu: Partial<MusteriSorgusu>) {
  return useQuery<SayfalanmisMusteriler>({
    queryKey: ['musteriler', 'liste', sorgu],
    queryFn: () => musterileriListele(istemci, sorgu),
    placeholderData: (onceki) => onceki,
  });
}

export function useMusteri(id: string | undefined | null) {
  return useQuery<Musteri>({
    queryKey: ['musteriler', 'detay', id ?? ''],
    queryFn: () => musteriGetir(istemci, id as string),
    enabled: !!id,
  });
}
